import styled from 'styled-components'
import UtilWrapper from 'frontend/src/components/util/UtilWrapper';
import SidebarContainer from 'frontend/src/components/sidebar/SidebarContainer';
import { usePage } from '../../contexts/PageProvider';
import { Breakpoint, Columns } from '../../styles/functions';
import SanityContent from '../sanity/content/SanityContent';
import PageFooter from './PageFooter';
import { TypeBodyM } from '../../styles/mixins';
import FormContact from '../form/FormContact';

function PageContact() {
  const page = usePage();

  return (
    <>
      <Container>
        <Sidebar isSticky={true} />
        <Content>
          <Heading>General Enquiry</Heading>
          <FormContact toEmail={page.contactToAddress} subject={page.contactSubject} />
        </Content>
      </Container>
      <PageFooter />
    </>
  )
}

const Container = styled(UtilWrapper)`
margin-top: var(--spacing-page-top);
margin-bottom: var(--spacing-200);
`

const Sidebar = styled(SidebarContainer)`
`

const Content = styled.div`
  ${TypeBodyM};
  
  ${Breakpoint('mobile', 'min')} {
    margin-left: ${Columns(8,0)};
    margin-right: ${Columns(6,0)};
  }
`

const Heading = styled.h1`
  margin-bottom: var(--spacing-40);
`

export default PageContact
